import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Button
} from "reactstrap";
import { inject, observer } from "mobx-react";
import { Link, Redirect } from "react-router-dom";
import DataWrapper from "../../../principal/containers/DataWrapper";
import ModalForm from "../../../comum/components/ModalForm";
import {
  IconeSoma,
  IconeFileImport,
  IconeMailBulk
} from "../../../comum/components/Icones";
import AgendamentoNotaFiscalStore from "../stores/AgendamentoNotaFiscalStore";
import FiltrosAgendamentoNotaFiscal from "../components/FiltrosAgendamentoNotaFiscal";
import { TabelaAgendamentoNotaFiscal } from "../components/TabelaAgendamentoNotaFiscal";

@inject("store")
@DataWrapper
@observer
export class AgendamentoNotaFiscal extends Component {
  constructor(props) {
    super(props);
    this.appStore = this.props.store.appStore;
    this.loginStore = this.props.store.loginStore;
    this.tituloPaginaStore = this.props.store.tituloPaginaStore;

    this.controller = new AgendamentoNotaFiscalStore();
  }

  componentDidMount() {
    this.tituloPaginaStore.setTitulo("Notas Fiscais");
    this.appStore.showTopbar(true);
    this.appStore.showVoltarTopBar(false, "/");
  }

  can = (operacao = "C", tarefa = "NotasFiscaisAde") => this.loginStore.can(tarefa, operacao)

  modalCarregarXML() {
    if (this.controller.mostrarModalXml) {
      return (
        <ModalForm
          salvando={this.controller.validandoXML}
          className="area-form-modal"
          onClickCancelar={this.controller.fecharModais}
          labelConfirmar="CARREGAR"
          esconderSalvar={
            this.controller.erroImportXML || !this.controller.jsonFile
          }
          onClickSalvar={this.controller.adicionarXMLNotaFiscal}
        >
          <Row>
            <Col sm={12} md={12}>
              <FormGroup>
                {this.controller.fileXMLType.includes('cte') && <h2>Opção exclusiva para embarque de cabotagem, em caso de indisponibilidade do XML da NFe.</h2>}
                <Label>Inserir arquivo</Label>
                <Input
                  type="file"
                  onChange={e => this.controller.guardaXMLNotaFiscal(e)}
                />
                {this.mensagemErroXML()}
              </FormGroup>
            </Col>
          </Row>
        </ModalForm>
      );
    }
  }

  mensagemErroXML() {
    return this.controller.erroImportXML ? (
      <div className="label-obrigatorio pt-2">
        <Label> {this.controller.erroImportXMLMensagem} </Label>
      </div>
    ) : null;
  }

  importarXML = () => {
    if (this.controller.importarXML && this.controller.jsonFile) {
      return (
        <Redirect
          to={{
            pathname: "/agendamento-nota-fiscal/cadastro",
            notaFiscalSel: this.controller.jsonFile,
            importacaoXML: true
          }}
        />
      );
    }
  };

  toolbar = () => {
    return (
      <Row>
        <Col className="justify-content-end d-flex mb-0">
          {this.can("I") &&
            <React.Fragment>
              {process.env.ssa && <Button
                onClick={() => this.controller.abrirInserirXMLNotaFiscal('cte')}
                className="btn-com-bordas-cinza"
              >
                <IconeFileImport tamanho="lg" className="mr-1" />
                Inserir XML do CTE
            </Button>}
              <Button
                onClick={() => this.controller.abrirInserirXMLNotaFiscal('xml')}
                className="btn-com-bordas-cinza"
              >
                <IconeFileImport tamanho="lg" className="mr-1" />
                Inserir XML
            </Button>
          </React.Fragment>
          }
          {this.can("C") && process.env.rig &&
            <Link to="/consulta-edi-nf">
              <Button className="btn-com-bordas-cinza">
                <IconeMailBulk tamanho="lg" className="mr-1" /> Consulta EDI NF
            </Button>
            </Link>
          }
          {this.can("I") &&
            <Link to="agendamento-nota-fiscal/cadastro">
              <Button className="btn-com-bordas-primary">
                Nova Nota Fiscal
            </Button>
            </Link>
          }
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <div className="form-wrapper">
        <Container className="tela-botoes-inclusao-topo" fluid>
          {this.importarXML()}
          {this.modalCarregarXML()}
          {this.toolbar()}
          <FiltrosAgendamentoNotaFiscal controller={this.controller} />
          <TabelaAgendamentoNotaFiscal controller={this.controller} />
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-visualizar/tela/AgendamentoNotaFiscal.js